const session = require('./session');
const collect = require('./collect');
const customAnalytics = require('./customAnalytics');

/**
 * Initialice each tracking related to abandoned cart feature
 */
function init() {
    // Session tracking must be always the first initialization
    session.init();

    collect.init();
    customAnalytics.init();
}

module.exports = {
    isAnonymousCustomer: session.isAnonymousCustomer,
    init
};
